import { Text } from "materials/text/menus/model"
export class Dialog extends Text {
  constructor(difference) {
    super()
    this.isCustomComponent = true
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
